<template>
  <div class="tip-box">
      <span class="tip"><strong>
        <span class="colorBlue">{{ title }}</span> {{ subTitle }}</strong><br/>
        <slot></slot>
      </span>
  </div>
</template>

<script>
export default {
  name: 'tipBox',
  props: {
    title: {
      type: String,
      required: false,
      default: '【ガイド】'
    },
    subTitle: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TipBox.vue